<div class="width-1100">

  <mat-card>
    <mat-toolbar class="toolbar-top">

      <div class='title' style='padding: 10px;'>
        CAEX - Cadastro
      </div>

      <button mat-button (click)='goBack()'>
        <mat-icon>arrow_back</mat-icon>
      </button>

    </mat-toolbar>
  </mat-card>

  <div class='div-progress'>
    <mat-progress-bar [ngClass]="{hidden: !spinner}" color='warn' mode="indeterminate">
    </mat-progress-bar>
  </div>

  <mat-card>

    <form [formGroup]="memberForm">

      <mat-form-field class="full-width">
        <mat-select  placeholder="Selecione uma empresa" (ngModelChange)='subCategorySelectedChange($event)' 
        [errorStateMatcher]="matcher" [formControl]="memberForm.controls.subCategory_id">
          <mat-option *ngFor="let subCat of subCategories" [value]="subCat.id">
            {{ subCat.name }}
          </mat-option>
        </mat-select>
        <mat-error *ngIf="memberForm.controls.subCategory_id.hasError('required')">
          Campo é obrigatório
        </mat-error>
      </mat-form-field>

      <div *ngIf="subCategorySelected.documents" style="width: 600px; padding:5px 10px 20px 5px; color: blue; ">
        Apresentar {{subCategorySelected.documents}}
      </div>

      <mat-form-field class="full-width">
        <input matInput type="text" [errorStateMatcher]="matcher" [formControl]="memberForm.controls.name"
          placeholder="Nome" autocomplete="off">
        <mat-error *ngIf="memberForm.controls.name.hasError('required')">
          O nome é obrigatório
        </mat-error>
      </mat-form-field>

      <mat-form-field class="full-width">
        <input matInput type="text" [errorStateMatcher]="matcher" [formControl]="memberForm.controls.email"
          placeholder="Email" autocomplete="off">
        <mat-error *ngIf="memberForm.controls.email.hasError('required')">
          O email é obrigatório
        </mat-error>
      </mat-form-field>

      <div>

        <mat-form-field class="prefix-width">
          <input matInput type="text" [errorStateMatcher]="matcher" [formControl]="memberForm.controls.cellPhonePrefix"
            placeholder="Pais" autocomplete="off">
          <mat-error *ngIf="memberForm.controls.cellPhonePrefix.hasError('required')">
            O pais é obrigatório
          </mat-error>
        </mat-form-field>

        <mat-form-field class="phone-width">
          <input matInput type="text" [errorStateMatcher]="matcher" [formControl]="memberForm.controls.cellPhone"
            placeholder="Celular" autocomplete="off">
          <mat-error *ngIf="memberForm.controls.cellPhone.hasError('required')">
            O celular é obrigatório
          </mat-error>
        </mat-form-field>

      </div>

      <mat-form-field class="field-width">
        <input matInput type="text" [errorStateMatcher]="matcher"
          [formControl]="memberForm.controls.cpf" placeholder="Doc" autocomplete="off">
        <mat-error *ngIf="memberForm.controls.cpf.hasError('required')">
          O Doc é obrigatório
        </mat-error>
      </mat-form-field>

      <!--
      <mat-form-field class="field-width">
        <input matInput type="text" [errorStateMatcher]="matcher" [formControl]="memberForm.controls.crm"
          placeholder="CRM" autocomplete="off">
        <mat-error *ngIf="memberForm.controls.crm.hasError('required')">
          O CRM é obrigatório
        </mat-error>
      </mat-form-field>
      -->

    </form>

    <div style="display:flex; flex-direction: row; justify-content: space-between;">

      <div style="height: 40px;">
        <button mat-raised-button (click)='updateMember()' [disabled]="memberForm.invalid"
          style='font-size: 14px; color:green; margin:10px 0 0 0;'>
          <mat-icon class='icon-done'>check_circle_outline</mat-icon>
        </button>
      </div>

    </div>

  </mat-card>


  <mat-card>
    <div style="height: 40px;">
      <button mat-raised-button (click)='getSubscriptions()' [disabled]="!_caexService.currentMember.cpf"
        style='width:100%; font-size: 14px; color:green; margin:10px 0 0 0;'>
        Inscrições
      </button>
    </div>
  </mat-card>

</div>